module.exports = __webpack_public_path__ + "img/RUN-HEELSTRIKE-A-DROITE.aaf2dc8a.svg";